import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { Guard } from '../../components/layout/Guard';

const List = lazy(() => import('./PoListPage'));
const Detail = lazy(() => import('./PoDetailPage'));
const Form = lazy(() => import('./PoFormPage'));

const routes: RouteObject[] = [
  { path: '/purchase-orders', element: <Guard any={['po.read']}><List /></Guard> },
  { path: '/purchase-orders/new', element: <Guard any={['po.create']}><Form /></Guard> },
  { path: '/purchase-orders/:id', element: <Guard any={['po.read']}><Detail /></Guard> },
  { path: '/purchase-orders/:id/edit', element: <Guard any={['po.create']}><Form /></Guard> },
];
export default routes;
